// FocusAnimation.js
import React from "react";
import Lottie from "react-lottie";
import focusAnimation from "./animations/focus.json"; // Adjust the path as needed

const FocusAnimation = () => {
  const defaultOptions = {
    loop: true, // The animation will replay continuously
    autoplay: true,
    animationData: focusAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Lottie options={defaultOptions} height={400} width={400} />
    </div>
  );
};

export default FocusAnimation;
